import React, { Component } from 'react';
import { connect } from 'react-redux'
import Navbar from './Navbar'
import { Redirect ,Link } from 'react-router-dom'
import axios from 'axios';

var tot = 0
var taxrate = 0.0915
class Diningdollar extends Component {
    constructor(props) {
        super(props);

        this.state={
           wid: localStorage.getItem('wid'),
            diningDollars:"",
            name:""
        }
    }
    componentDidMount(){
        if(localStorage.getItem("wid")){
           
        fetch('https://apps2.housing.k-state.edu/code/jpsatjardine/diningDollargetInfo.php?wid='+this.state.wid)
        .then((response) => {
            return response.json();
        }).then(data => {
          var data =data.data;
          this.setState({ diningDollars: parseFloat(data[0].DiningDollars).toFixed(2) })
          this.setState({ name: data[0].first_name+" "+ data[0].last_name })

        });
  
        }
    }


    handleCheckOut = (e)=>{
        var that = this;
         const bodyFormData = new FormData();
         bodyFormData.append('total', this.props.total);
         bodyFormData.append('idOrder', this.props.location.state.idOrder);
         bodyFormData.append('wid', this.state.wid);
         
         axios.post(`https://apps2.housing.k-state.edu/code//JPsatJardine/diningDollarPayment.php`, bodyFormData)
         .then(function (response) {
           
            var idOrder =response.data;
            if(idOrder){
                localStorage.setItem("idOrder",idOrder);
                that.props.history.push('/confirm')
            }
         })

    }

    render(){
        var totalWithTax=0
        tot = parseFloat(this.props.total)
        var totTax = parseFloat((tot * taxrate)).toFixed(2)
        totalWithTax = parseFloat((parseFloat(tot) + parseFloat(totTax)).toFixed(2));
        var showMessage = false;
        if(this.props.location.state.idOrder){
        var idOrder = this.props.location.state.idOrder
     }
      // alert(this.props.location.state.idOrder)
        //if(this.state.diningDollars){
       // var diningDollars = parseFloat(this.state.diningDollars)
   // }
   if(totalWithTax < this.state.diningDollars ){
    showMessage = true;
   }

        return(
            <div>
            <Navbar isAuthed={true}/>
            <div className="container" ><br/><br/>
            <div class="collection cartUl "> 
           &nbsp;&nbsp;<h5>Dining Dollar Payment</h5> 
           
          {/* <label  class="myinfo" style={{color:"Black"}}><b>Name:</b> {this.state.name}</label><br/>
           <label  class="myinfo" style={{color:"Black"}}><b>Account Balance:</b> {this.state.diningDollars}</label>
          */}
           <h6><b>Name:</b> {this.state.name}  </h6>
           <h6><b>Dining Dollar Balance:</b> ${this.state.diningDollars}  </h6>  
           <h6><b>Order Total :</b> ${totalWithTax}</h6>
            {showMessage  ? <div><button  className="btn"  onClick={()=>{this.handleCheckOut(this.props)}} value="Pay">Pay Now</button>
        
            <Link to="/cart" className=" btn red">Cancel</Link>
            </div> :<div className="container"><div class="materialert danger ">
                        <div class="material-icons">error_outline</div>
                        You don't have enough dining dollars on your account. Please use credit card to make the payment.
		</div> <Link to="/cart" className=" btn red">Go back</Link></div>}
       
           </div>
           </div>
            </div>
        )
    }

}

const mapStateToProps = (state)=>{
    return{
        orders: state.orders,
        total: state.total,
        
    }
}

const mapDispatchToProps = (dispatch)=>{
    return{
        addShipping: ()=>{dispatch({type: 'ADD_SHIPPING'})},
        substractShipping: ()=>{dispatch({type: 'SUB_SHIPPING'})}
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Diningdollar)